import type { User } from '@/types/api';

/**
 * The name the interstitial calls the signed-in person by: "Full Name (email)".
 * The full name when both names exist, else whichever exists, and always the
 * email in parentheses, so two people who share a first name stay distinct.
 * With no name at all, the email alone.
 */
export function displayNameOf(u: Pick<User, 'email' | 'name' | 'profile'>): string {
  const first = u.profile?.first_name?.trim() ?? '';
  const last = u.profile?.last_name?.trim() ?? '';
  const name = [first, last].filter(Boolean).join(' ') || u.name?.trim() || '';
  const email = u.email?.trim() ?? '';
  if (!name) return email;
  return email ? `${name} (${email})` : name;
}
